// extracted by css-extract-rspack-plugin
export default {"form":"form--zMgm3TSvi8E5jA2R"};